import script from "./WhitelistPhoneBoxComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WhitelistPhoneBoxComponent.vue?vue&type=script&setup=true&lang=js"

import "./WhitelistPhoneBoxComponent.vue?vue&type=style&index=0&id=92cd763c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92cd763c"]])

export default __exports__